import React from 'react';
import Dialog from '@material-ui/core/Dialog';
import WebFont from 'webfontloader';

// todo in admin this is loaded via API call, but it is an authenticated call so simply hard coding for now
export interface Font {
    id: string;
    name: string;
    enabled: boolean;
}
export const fonts: Font[] = [{ id: '1', name: 'Mr Dafoe', enabled: true }];

export interface SigningFontModalProps {
    isOpen: boolean;
    signatureText: string;
    confirmCallback: (x: unknown) => void;
    cancelCallback: () => void;
    defaultSignature: boolean;
}

export const SigningFontModal: React.FC<SigningFontModalProps> = ({
    isOpen,
    signatureText,
    confirmCallback,
    cancelCallback,
    defaultSignature = false,
}) => {
    const [googleFonts] = React.useState<Font[]>(fonts);
    const [selectedFont, setSelectedFont] = React.useState<Font | undefined>(undefined);

    React.useEffect(() => {
        _loadGoogleFonts();
    }, []);

    const _loadGoogleFonts = () => {
        const fontNames = fonts.map((font) => font.name);
        WebFont.load({
            google: {
                families: fontNames,
            },
        });
        if (defaultSignature) {
            confirmCallback(fonts[0]);
        }
    };

    const _handleConfirm = () => confirmCallback(selectedFont);
    const _handleCancel = () => cancelCallback();

    const styles = {
        buttonMarginRight: {
            marginRight: '20px',
        },
        buttonDiv: {
            paddingTop: 20,
            paddingRight: 10,
            paddingBottom: 0,
            paddingLeft: 10,
        },
        radioLabel: {
            fontSize: 24,
            paddingLeft: 20,
        },
        h1Width: {
            flex: 'none',
            maxWidth: 'none',
        },
        noPadding: {
            padding: 0,
        },
        modal: {
            width: 440,
            overflow: 'hidden',
        },
        autoHeight: {
            height: 'auto',
        },
    };
    return (
        <Dialog
            maxWidth='lg'
            open={isOpen}
            onClose={_handleCancel}
            aria-labelledby='form-dialog-title'
        >
            <div className='modal-container'>
                <div className='modal-backdrop'></div>
                <div
                    className='modal'
                    tabIndex={-1}
                    role='dialog'
                    style={styles.modal}
                >
                    <div
                        className='modal-dialog'
                        role='document'
                    >
                        <div
                            className='page-header'
                            role='banner'
                        >
                            <h1 style={styles.h1Width}>Please select your signature</h1>
                            <button
                                type='button'
                                className='close'
                                data-dismiss='modal'
                                aria-label='Close'
                                onClick={_handleCancel}
                            >
                                <span aria-hidden='true'>&times;</span>
                            </button>
                        </div>
                        <div className='main-content no-search'>
                            <div
                                className='scrollable-content'
                                style={styles.autoHeight}
                            >
                                <div className='standard-form'>
                                    <div className='row'>
                                        <div className='columns small-12'>
                                            {googleFonts &&
                                                googleFonts.map((font) => {
                                                    const style = {
                                                        ...styles.radioLabel,
                                                        fontFamily: font.name,
                                                    };
                                                    return (
                                                        <div
                                                            className='radio'
                                                            key={font.id}
                                                        >
                                                            <label style={style}>
                                                                <input
                                                                    type='radio'
                                                                    value={font.id}
                                                                    data-testid={`font-radio-button-${font.id}`}
                                                                    checked={!!selectedFont && selectedFont.id === font.id}
                                                                    onChange={(event) => {
                                                                        setSelectedFont(
                                                                            googleFonts.find((g) => g.id === event.target.value)
                                                                        );
                                                                    }}
                                                                    style={{
                                                                        marginRight: 10,
                                                                    }}
                                                                />
                                                                {signatureText}
                                                            </label>
                                                        </div>
                                                    );
                                                })}
                                        </div>
                                    </div>
                                </div>
                                <div
                                    className='button-footer'
                                    style={{ paddingLeft: '20px' }}
                                >
                                    <button
                                        style={styles.buttonMarginRight}
                                        type='submit'
                                        className='button primary'
                                        disabled={selectedFont === undefined}
                                        onClick={_handleConfirm}
                                        data-testid='signature-select-submit'
                                    >
                                        Sign
                                    </button>
                                    <button
                                        type='button'
                                        className='button hollow'
                                        data-dismiss='modal'
                                        onClick={_handleCancel}
                                        data-testid='signature-select-cancel'
                                    >
                                        Cancel
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Dialog>
    );
};
